import AuthForm from '@pages/Auth/AuthForm.tsx';

const Auth = () => {
  return <AuthForm />;
};

export default Auth;
